// extracted by mini-css-extract-plugin
export var button = "styles-module--button--9699a";
export var comparisonItem = "styles-module--comparisonItem--98a0c";
export var comparisonItems = "styles-module--comparisonItems--3d7c1";
export var content = "styles-module--content--31222";
export var contentContainer = "styles-module--contentContainer--8fb8d";
export var description = "styles-module--description--d8174";
export var label = "styles-module--label--5ecbb";
export var price = "styles-module--price--90d69";
export var section = "styles-module--section--a85b8";